export const CB_RULES = [
  {
    key: "goms",
    label: "Meet the GoMs",
    goms: [
      {
        name: "Yani",
        shop: "ArekuTrades",
        mark: "🎀",
        facts: [
          "38", "Spendtiny", "Florida, USA Based", "ENTJ | Virgo", "Atiny since Dec 2019", "Into Kpop since 2010",
          "Bias: Yunho", "Wreckers: WooGi", "I love sewing", "Never ending Love/Hate with League of Legends",
        ],
      },
      {
        name: "Ceecee",
        shop: "ThePastelFix",
        mark: "🍰",
        facts: [
          "38", "Artiny", "Seoul, KR based", "INFP/J | Aries", "Atiny since 2022", "Into Kpop since 2019",
          "Bias: OT8 with a San problem", "Wreckers: All of them 😭",
          "Addicted to arts and crafts. You can find me drawing or slaving over my sewing machine.",
        ],
      },
    ],
  },
  {
    key: "go-info",
    label: "Go Info & Rules",
    items: [
      { title: "Communication", body: "All GO updates and drop info will be posted to the main GH6 GO GC. Any non-GO communication should go in the GH6 Discussion Chat to limit important info being lost in the GO GC" },
      { title: "Deadlines", body: "Please read payment and claim deadlines carefully. Repeat failure to adhere to deadline will result in a warning first and then removal from the claim group" },
      { title: "Sorting is possible", body: "While a lot of shops so provide ot8 sets sometimes it is not guaranteed. In the event that sorting is required we will relay this to the group chat with what we received, what we are missing, and who will need to fill out a sorting form." },
      { title: "Split Claims", body: "If 7/8 members are claimed in a set the 8th unclaimed member will be split claim among those in that GO. The unclaimed 8th PC will be raffled later on among joiners in that round." },
      { title: "Shipping", body: "Items will arrive to Thepastelfix in Korea initially. They will be checked and sorted before being sent out to ArekuTrades in the US or directly to KR/WW based joiners. Please be aware this takes times as checking items, opening albums, sorting, etc is time consuming so we will ship out in batches every 3-4 weeks. The batch shipping is to keep EMS costs low and send outs are based upon we actually receive shipments from the stores." },
      { title: "Specialty Drops", body: "There may be special drops during cb including but not limited to popups, broadcasts, cafes, etc. Those in the comeback claim group will have priority to claiming these items before anything is posted to the public. You are not limited to your claim member but it will be first come on claims." },
    ],
  },
  {
    key: "fancalls",
    label: "Fancalls",
    items: [
      { body: "You must have a passport along with a Line and KakaoTalk account. While some stores do accept IDs because of the changing rules at times its best to be prepared with passport as we are not responsible if you are turned away from your call for improper identification." },
      { body: "You must be okay with providing personal information for the call as most stores require: Full Legal Name, DoB, Phone Number, Email, and KakaoTalk & Line." },
      { body: "If you have won for your fancall raffle attempt with the member we entered you for this comeback you are not eligible to enter with us again. If you don’t win for your round with the store than you can go back on the wheel for one more try that cb after everyone else has tried." },
      {
        title: "Fancall PC sets",
        body: "In the case a joiner is a fancall winner during a round in which PC sets are given division will occur as following:",
        steps: [
          "Winning Joiner will have first pick of the Winner PC they would like to receive",
          "GoMs will choose one PC for themselves",
          "The remaining PCs will be raffled off to all the joiners that helped in winning the set.",
        ],
      },
      { body: "GoMs may attempt a fancall/fansign during the CB for a member of their choosing. When this is the case it will be clearly stated for joiners ahead of time before they decide to join." },
    ],
  },
  {
    key: "supply-fee",
    label: "Supply/Material Fee",
    paragraph: "We will add a supply/material fee per joiner when it is time for EMS to be calculated. This fee will be added to your EMS or DoMs payment. Please understand that while we do the service of running GOs at no cost this does not mean we will incur the cost of the packing supplies needed to ensure items go out safely which include but not limited to: Shipping Shields, Bubble Wrap, Poly Mailers, Boxes, Labels, Stamps, Envelopes, etc.",
  },
  {
    key: "payment",
    label: "Payment Info and Rules",
    items: [
      { body: "Preferred payment methods will be listed in each GOs notion along with instructions for how to submit payment. Please read carefully as payment can go to either GoM depending on who is ordering that round." },
      { body: "GO pricing will generally be for the PoB and PC inclusions unless otherwise stated." },
      { body: "Pricing in Won is only for those with KR bank accounts. Do not send in won via Wise, use only USD when using this payment method." },
      { body: "For limited time drops it will be pay as you claim to ensure items don’t sell out. If you would like to pre-pay for claims for rounds such as Lucky Draws that maybe limited to ensure your member you can do so." },
    ],
  },
];
